import { render, staticRenderFns } from "./heats-table-simple.vue?vue&type=template&id=5f152c49&lang=pug"
import script from "./heats-table-simple.vue?vue&type=script&lang=coffee"
export * from "./heats-table-simple.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports